/*
 * Kokoro Story-Fenster (27.09.2026)
 *
 * Tippt jemand im Video-Slider auf eine Kachel, oeffnet sich das Video
 * bildschirmfuellend wie eine Instagram-Story: mit Ton, mit Wischen zum
 * naechsten Video, Schliessen ueber das X oder Wischen nach unten.
 *
 * Grund: die Kacheln im Slider sind nur rund 106 Pixel breit. Darauf erkennt
 * man nichts. Vorher machte ein Tippen nur den Ton an, es gab keinen Weg,
 * das Video gross zu sehen.
 *
 * Der Klick wird in der Aufnahme-Phase abgefangen, damit die vorhandene
 * Ton-an-Logik des Slider-Blocks nicht zusaetzlich feuert.
 */
(function () {
  'use strict';

  var KACHEL = '[class*="lumin-video-wrapper-"]';
  var TONKNOPF = '[class*="lumin-video-mute-button-"]';
  var SLIDER = '[class*="lumin-video-swiper-"]';
  var KOPIE = '[class*="lumin-video-swiper-clone-"]';

  var stil = document.createElement('style');
  stil.textContent = [
    /*
     * Sichtbar per Voreinstellung, das Einblenden macht eine Animation.
     * Kein opacity:0 als Ausgangswert und kein Umschalten per Javascript:
     * in gedrosselten Tabs laufen Zeitgeber und Uebergaenge nicht, dann
     * bliebe das Fenster unsichtbar stehen. Die Animation startet von
     * allein neu, sobald display von none auf flex wechselt.
     */
    '@keyframes kokoroStoryAuf{from{opacity:0}to{opacity:1}}',
    /* Kokoro 18.10.2026: Seite dahinter verschwommen, Video als Karte im Hochformat in der Mitte. */
    '@keyframes kokoroStoryKarte{from{opacity:0;transform:scale(.94)}to{opacity:1;transform:scale(1)}}',
    '.kokoro-story{position:fixed;inset:0;z-index:2147483600;background:rgba(20,20,20,.38);-webkit-backdrop-filter:blur(16px);backdrop-filter:blur(16px);display:flex;align-items:center;justify-content:center;opacity:1;animation:kokoroStoryAuf .18s ease;}',
    '.kokoro-story__karte{position:relative;height:min(92dvh,calc(94vw * 16 / 9));aspect-ratio:9/16;border-radius:14px;overflow:hidden;background:#000;box-shadow:0 20px 60px rgba(0,0,0,.4);animation:kokoroStoryKarte .26s cubic-bezier(.22,1,.36,1);}',
    '.kokoro-story__pfeil{position:absolute;top:50%;z-index:4;width:36px;height:36px;margin-top:-18px;border:0;border-radius:50%;background:rgba(0,0,0,.45);color:#fff;cursor:pointer;padding:0;display:flex;align-items:center;justify-content:center;}',
    '.kokoro-story__pfeil svg{width:18px;height:18px;display:block;}',
    '.kokoro-story__pfeil--zurueck{left:10px;}',
    '.kokoro-story__pfeil--weiter{right:10px;}',
    '@media (hover:none){.kokoro-story__pfeil{display:none;}}',
    /* Kokoro 18.10.2026: Standbild sofort als Kartenhintergrund, Video blendet ein, sobald es laeuft - kein Schwarzbild mehr. */
    '.kokoro-story__karte{background:#1a1a1a center/cover no-repeat;}',
    '.kokoro-story__video{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;background:transparent;opacity:0;transition:opacity .2s ease;}',
    '.kokoro-story__video.is-bereit{opacity:1;}',
    '@keyframes kokoroStoryDreh{to{transform:rotate(360deg)}}',
    '.kokoro-story__lader{position:absolute;top:50%;left:50%;z-index:3;width:34px;height:34px;margin:-17px 0 0 -17px;border-radius:50%;border:3px solid rgba(255,255,255,.35);border-top-color:#fff;animation:kokoroStoryDreh .8s linear infinite;pointer-events:none;}',
    '.kokoro-story__karte.is-bereit .kokoro-story__lader{display:none;}',
    '.kokoro-story__balken{position:absolute;top:10px;left:10px;right:10px;display:flex;gap:4px;z-index:3;}',
    '.kokoro-story__balken span{flex:1;height:3px;border-radius:3px;background:rgba(255,255,255,.3);overflow:hidden;}',
    '.kokoro-story__balken i{display:block;height:100%;width:0;background:#fff;border-radius:3px;}',
    '.kokoro-story__schliessen{position:absolute;top:22px;right:10px;z-index:4;width:36px;height:36px;border:0;border-radius:50%;background:rgba(0,0,0,.45);color:#fff;font-size:24px;line-height:36px;cursor:pointer;padding:0;}',
    '.kokoro-story__ton{position:absolute;top:22px;right:54px;z-index:4;width:36px;height:36px;border:0;border-radius:50%;background:rgba(0,0,0,.45);color:#fff;cursor:pointer;padding:0;display:flex;align-items:center;justify-content:center;}',
    '.kokoro-story__ton svg{width:20px;height:20px;display:block;}',
    '.kokoro-story__ton .kokoro-story__aus{display:none;}',
    '.kokoro-story__ton[data-stumm="ja"] .kokoro-story__an{display:none;}',
    '.kokoro-story__ton[data-stumm="ja"] .kokoro-story__aus{display:block;}',
    '.kokoro-story__zone{position:absolute;top:0;bottom:0;width:32%;border:0;background:transparent;cursor:pointer;z-index:2;padding:0;}',
    '.kokoro-story__zone--zurueck{left:0;}',
    '.kokoro-story__zone--weiter{right:0;}',
    '.kokoro-story__zone--pause{left:32%;width:36%;}',
    '.kokoro-story__pausezeichen{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);z-index:3;width:76px;height:76px;border-radius:50%;background:rgba(0,0,0,.5);display:none;align-items:center;justify-content:center;pointer-events:none;}',
    '.kokoro-story__pausezeichen svg{width:34px;height:34px;color:#fff;display:block;margin-left:4px;}',
    '.kokoro-story[data-pause="ja"] .kokoro-story__pausezeichen{display:flex;}',
    'body.kokoro-story-offen{overflow:hidden;}'
  ].join('');
  document.head.appendChild(stil);

  var fenster = null;
  var liste = [];
  var stelle = 0;
  var vorherScroll = 0;

  function quelleVon(v) {
    if (!v) return '';
    var s = v.currentSrc || v.getAttribute('src') || '';
    if (s) return s;
    var q = v.querySelector('source');
    return q ? q.src : '';
  }

  /*
   * closest() liefert den NAECHSTEN Treffer, und das ist hier die einzelne
   * Kachel (lumin-video-swiper-slide-...), nicht der ganze Slider. Deshalb
   * bis zum aeussersten passenden Vorfahren hochlaufen.
   */
  function aeussersterSlider(el) {
    var treffer = null;
    var e = el;
    while (e && e.closest) {
      var t = e.closest(SLIDER);
      if (!t) break;
      treffer = t;
      e = t.parentElement;
    }
    return treffer;
  }

  /*
   * Der Slider legt fuer die Endlosschleife unsichtbare Kopien der Kacheln
   * an, und die stehen im HTML VOR den echten. Zaehlt man sie mit, stimmt
   * die Reihenfolge nicht: Video 1 landete als dritter Balken. Deshalb nur
   * die echten Kacheln nehmen und nur zurueckfallen, wenn gar keine da sind.
   */
  function quellen(slider) {
    var wurzel = slider || document;
    var echte = [];
    var alle = [];
    Array.prototype.forEach.call(wurzel.querySelectorAll(KACHEL), function (k) {
      var v = k.querySelector('video');
      var src = quelleVon(v);
      if (!src) return;
      /* Das Standbild der Kachel liegt schon im Zwischenspeicher des Browsers
         und ist sofort da, waehrend das Video noch laedt. */
      var bild = (v && v.getAttribute('poster')) || '';
      if (!bild) {
        var img = k.querySelector('img');
        if (img) bild = img.currentSrc || img.src || '';
      }
      var eintrag = { src: src, bild: bild };
      alle.push(eintrag);
      if (!k.closest(KOPIE)) echte.push(eintrag);
    });
    var quelle = echte.length ? echte : alle;
    var gesehen = {};
    return quelle.filter(function (e) {
      if (gesehen[e.src]) return false;
      gesehen[e.src] = true;
      return true;
    });
  }

  function stelleVon(src) {
    for (var i = 0; i < liste.length; i++) {
      if (liste[i].src === src) return i;
    }
    return -1;
  }

  function seiteAnhalten() {
    Array.prototype.forEach.call(document.querySelectorAll('video'), function (v) {
      if (fenster && fenster.contains(v)) return;
      v.pause();
      v.muted = true;
    });
  }

  function seiteWeiter() {
    Array.prototype.forEach.call(document.querySelectorAll('video'), function (v) {
      if (fenster && fenster.contains(v)) return;
      var r = v.getBoundingClientRect();
      if (r.bottom > 0 && r.top < window.innerHeight) {
        v.muted = true;
        v.play().catch(function () {});
      }
    });
  }

  function balkenBauen() {
    var b = fenster.querySelector('.kokoro-story__balken');
    b.innerHTML = '';
    liste.forEach(function () {
      var s = document.createElement('span');
      s.appendChild(document.createElement('i'));
      b.appendChild(s);
    });
  }

  function pauseZeichenSetzen() {
    if (!fenster) return;
    var v = fenster.querySelector('.kokoro-story__video');
    fenster.setAttribute('data-pause', v && v.paused ? 'ja' : 'nein');
  }

  function umschalten() {
    if (!fenster) return;
    var v = fenster.querySelector('.kokoro-story__video');
    if (!v) return;
    if (v.paused) {
      v.play().catch(function () {});
    } else {
      v.pause();
    }
    pauseZeichenSetzen();
  }

  function tonKnopfSetzen() {
    if (!fenster) return;
    var knopf = fenster.querySelector('.kokoro-story__ton');
    var v = fenster.querySelector('.kokoro-story__video');
    if (!knopf || !v) return;
    knopf.setAttribute('data-stumm', v.muted ? 'ja' : 'nein');
  }

  function balkenSetzen(anteil) {
    var teile = fenster.querySelectorAll('.kokoro-story__balken i');
    for (var i = 0; i < teile.length; i++) {
      teile[i].style.width = i < stelle ? '100%' : (i === stelle ? (anteil * 100) + '%' : '0%');
    }
  }

  function zeigen(i) {
    if (i < 0) i = 0;
    if (i >= liste.length) { schliessen(); return; }
    stelle = i;
    var v = fenster.querySelector('.kokoro-story__video');
    var karte = fenster.querySelector('.kokoro-story__karte');
    v.classList.remove('is-bereit');
    karte.classList.remove('is-bereit');
    karte.style.backgroundImage = liste[stelle].bild ? 'url("' + liste[stelle].bild + '")' : '';
    if (liste[stelle].bild) v.setAttribute('poster', liste[stelle].bild);
    v.src = liste[stelle].src;
    /* Ohne load() startet ein wiederverwendetes Element in manchen Browsern
       nicht neu, vor allem im eingebetteten Rahmen des Shopify-Editors. */
    v.load();
    v.currentTime = 0;
    v.muted = false;
    v.play().catch(function () {
      /* Blockt der Browser den Ton, laeuft es wenigstens stumm weiter. */
      v.muted = true;
      tonKnopfSetzen();
      v.play().catch(function () {});
    });
    tonKnopfSetzen();
    balkenSetzen(0);
  }

  function bauen() {
    fenster = document.createElement('div');
    fenster.className = 'kokoro-story';
    fenster.setAttribute('role', 'dialog');
    fenster.setAttribute('aria-modal', 'true');
    fenster.innerHTML =
      '<div class="kokoro-story__karte">' +
      '<div class="kokoro-story__lader" aria-hidden="true"></div>' +
      '<div class="kokoro-story__balken"></div>' +
      '<button class="kokoro-story__schliessen" type="button" aria-label="Schliessen">&times;</button>' +
      '<button class="kokoro-story__ton" type="button" aria-label="Ton an oder aus">' +
        '<svg class="kokoro-story__an" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">' +
          '<path d="M4 9v6h4l5 4V5L8 9H4z"/>' +
          '<path d="M16.5 8.5a5 5 0 0 1 0 7" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>' +
          '<path d="M19 6a8 8 0 0 1 0 12" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>' +
        '</svg>' +
        '<svg class="kokoro-story__aus" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">' +
          '<path d="M4 9v6h4l5 4V5L8 9H4z"/>' +
          '<path d="M16.5 9.5l5 5m0-5l-5 5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>' +
        '</svg>' +
      '</button>' +
      '<video class="kokoro-story__video" playsinline webkit-playsinline preload="auto"></video>' +
      '<button class="kokoro-story__zone kokoro-story__zone--zurueck" type="button" aria-label="Vorheriges Video"></button>' +
      '<button class="kokoro-story__zone kokoro-story__zone--pause" type="button" aria-label="Anhalten oder weiter abspielen"></button>' +
      '<button class="kokoro-story__zone kokoro-story__zone--weiter" type="button" aria-label="Naechstes Video"></button>' +
      '<div class="kokoro-story__pausezeichen" aria-hidden="true">' +
        '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M8 5l11 7-11 7V5z"/></svg>' +
      '</div>' +
      '<button class="kokoro-story__pfeil kokoro-story__pfeil--zurueck" type="button" aria-label="Vorheriges Video"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 18l-6-6 6-6"/></svg></button>' +
      '<button class="kokoro-story__pfeil kokoro-story__pfeil--weiter" type="button" aria-label="Naechstes Video"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 18l6-6-6-6"/></svg></button>' +
      '</div>';
    document.body.appendChild(fenster);

    var v = fenster.querySelector('.kokoro-story__video');
    v.addEventListener('timeupdate', function () {
      if (v.duration) balkenSetzen(v.currentTime / v.duration);
    });
    v.addEventListener('ended', function () { zeigen(stelle + 1); });
    v.addEventListener('playing', function () {
      v.classList.add('is-bereit');
      fenster.querySelector('.kokoro-story__karte').classList.add('is-bereit');
    });

    /*
     * Zweiter Versuch, sobald genug Daten da sind. Im eingebetteten Rahmen
     * des Shopify-Editors lehnt der Browser den ersten play()-Aufruf oft ab,
     * dann stand nur das Standbild da und nichts passierte.
     */
    v.addEventListener('canplay', function () {
      if (!v.paused || fenster.style.display === 'none') return;
      v.play().catch(function () {
        v.muted = true;
        tonKnopfSetzen();
        v.play().catch(function () {});
      });
    });

    /*
     * Ton-Knopf. iPhones blocken Ton, wenn der Browser den Start nicht als
     * klare Nutzeraktion wertet. Dann laeuft das Video stumm an und der Knopf
     * zeigt das ehrlich, statt dass der Kunde ratlos davorsteht.
     */
    v.addEventListener('volumechange', tonKnopfSetzen);
    fenster.querySelector('.kokoro-story__ton').addEventListener('click', function (e) {
      e.stopPropagation();
      v.muted = !v.muted;
      if (!v.muted && v.paused) v.play().catch(function () {});
      tonKnopfSetzen();
    });

    /*
     * Anhalten. Vorher lief das Video ohne Unterbrechung durch, man konnte
     * an keiner Stelle stehenbleiben. Mitte tippen haelt an, nochmal tippen
     * laeuft weiter, am Rechner geht auch die Leertaste.
     */
    fenster.querySelector('.kokoro-story__zone--pause').addEventListener('click', umschalten);
    v.addEventListener('play', pauseZeichenSetzen);
    v.addEventListener('pause', pauseZeichenSetzen);

    fenster.querySelector('.kokoro-story__schliessen').addEventListener('click', schliessen);
    /* Klick auf den verschwommenen Hintergrund schliesst. */
    fenster.addEventListener('click', function (e) { if (e.target === fenster) schliessen(); });
    fenster.querySelector('.kokoro-story__pfeil--zurueck').addEventListener('click', function () {
      if (stelle === 0) { v.currentTime = 0; } else { zeigen(stelle - 1); }
    });
    fenster.querySelector('.kokoro-story__pfeil--weiter').addEventListener('click', function () { zeigen(stelle + 1); });
    fenster.querySelector('.kokoro-story__zone--zurueck').addEventListener('click', function () {
      if (stelle === 0) { v.currentTime = 0; } else { zeigen(stelle - 1); }
    });
    fenster.querySelector('.kokoro-story__zone--weiter').addEventListener('click', function () {
      zeigen(stelle + 1);
    });

    /* Wischen: seitlich blaettern, nach unten schliessen. */
    var startX = 0, startY = 0;
    fenster.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
    }, { passive: true });
    fenster.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - startX;
      var dy = e.changedTouches[0].clientY - startY;
      if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy)) {
        zeigen(dx < 0 ? stelle + 1 : stelle - 1);
      } else if (dy > 90 && Math.abs(dy) > Math.abs(dx)) {
        schliessen();
      }
    }, { passive: true });
  }

  function oeffnen(slider, src) {
    liste = quellen(slider);
    if (!liste.length) return;
    if (!fenster) bauen();
    balkenBauen();
    vorherScroll = window.scrollY;
    document.body.classList.add('kokoro-story-offen');
    seiteAnhalten();
    fenster.style.display = 'flex';
    var i = stelleVon(src);
    zeigen(i < 0 ? 0 : i);
  }

  function schliessen() {
    if (!fenster) return;
    var v = fenster.querySelector('.kokoro-story__video');
    v.pause();
    v.removeAttribute('src');
    v.load();
    fenster.style.display = 'none';
    document.body.classList.remove('kokoro-story-offen');
    window.scrollTo(0, vorherScroll);
    seiteWeiter();
  }

  document.addEventListener('keydown', function (e) {
    if (!fenster || fenster.style.display === 'none') return;
    if (e.key === 'Escape') {
      schliessen();
    } else if (e.key === ' ' || e.key === 'Spacebar') {
      e.preventDefault();
      umschalten();
    } else if (e.key === 'ArrowRight') {
      zeigen(stelle + 1);
    } else if (e.key === 'ArrowLeft') {
      zeigen(stelle - 1);
    }
  });

  /* Aufnahme-Phase: vor der Ton-an-Logik des Slider-Blocks. */
  document.addEventListener('click', function (e) {
    if (fenster && fenster.contains(e.target)) return;
    if (!e.target || !e.target.closest) return;
    if (e.target.closest(TONKNOPF)) return;
    var kachel = e.target.closest(KACHEL);
    if (!kachel) return;
    var src = quelleVon(kachel.querySelector('video'));
    if (!src) return;
    e.preventDefault();
    e.stopPropagation();
    oeffnen(aeussersterSlider(kachel), src);
  }, true);
})();
